
import { Component, Prop, Vue } from "vue-property-decorator";
import { API_TCaseOnlineApplicationRows } from "@/models/case_online_application";
import { SMToaster, SMUser } from "@/store";
import copy from "copy-to-clipboard";

@Component
export default class CaseOnlineApplicationRow extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly rows!: API_TCaseOnlineApplicationRows[];
  @Prop([String, Boolean]) readonly label: string | boolean | undefined;
  @Prop({ type: Boolean }) readonly isLooped!: boolean | undefined;

  get groups() {
    const { rows } = this;

    if (!this.isLooped) return { 0: rows };

    return this.groupBy(rows, "loop_index");
  }

  groupBy(payload: API_TCaseOnlineApplicationRows[], key: string | number) {
    return payload.reduce((acc: any, cur: any) => {
      acc[cur[key]] = acc[cur[key]] || [];

      acc[cur[key]].push(cur);

      return acc;
    }, {});
  }

  getAliasResult(aliasResult: string): string {
    switch (aliasResult) {
      case "true":
        return "Yes";
      case "false":
        return "No";
      case "<nil>":
        return "-";
      case "":
        return "-";
      case null:
        return "-";
      default:
        return aliasResult
          .toString()
          .replaceAll(",,", ", ")
          .trim();
    }
  }

  onRightClick(result: string) {
    if (!result) return;

    if (!SMUser.isExpert) return;

    const text = this.getAliasResult(result);

    if (!text) return;

    copy(text);

    SMToaster.emitSuccess({
      title: this.$root.$tc("notification.copied").toString(),
      message: text,
    });
  }
}
